import _defineProperty from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { __rest } from "tslib";
import axios from 'axios';
import { Base64 } from 'js-base64/base64';
export var StatusCode;

(function (StatusCode) {
  StatusCode[StatusCode["OK"] = 200] = "OK";
  StatusCode[StatusCode["BadRequest"] = 400] = "BadRequest";
  StatusCode[StatusCode["Unauthorized"] = 401] = "Unauthorized";
  StatusCode[StatusCode["Forbidden"] = 403] = "Forbidden";
  StatusCode[StatusCode["NotFound"] = 404] = "NotFound";
  StatusCode[StatusCode["InternalServerError"] = 500] = "InternalServerError";
})(StatusCode || (StatusCode = {}));

axios.defaults.withCredentials = true;
var config = {};
export function configure(cfg) {
  config = cfg;
}
export function setDeviceInfoProvider(provider) {
  config.deviceInfoProvider = provider;
}
export function setResponseErrorHandler(handler) {
  config.responseErrorHandler = handler;
}
export function setToken(token) {
  config.token = token;
}
export function getHeaders() {
  if (!config.headers) return undefined;
  return Object.entries(config.headers).reduce(function (agg, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    var value = typeof v === 'function' ? v() : v;

    if (typeof value === 'undefined') {
      return agg;
    }

    return Object.assign(Object.assign({}, agg), _defineProperty({}, k, value));
  }, {});
}
export function setHeaders(headers) {
  config.headers = Object.assign(Object.assign({}, config.headers), headers);
}

function getConfig() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var headers = options.headers,
      rest = __rest(options, ["headers"]);

  var _config = config,
      responseErrorHandler = _config.responseErrorHandler,
      token = _config.token,
      _headers = _config.headers,
      defaults = __rest(config, ["responseErrorHandler", "token", "headers"]);

  var cfg = Object.assign(Object.assign({}, defaults), rest);
  var mergedHeaders = Object.assign(Object.assign({}, getHeaders()), headers || {});

  if (token && !mergedHeaders['Authorization']) {
    mergedHeaders['Authorization'] = token;
  }

  if (Object.keys(mergedHeaders).length) {
    cfg.headers = mergedHeaders;
  }

  return cfg;
}

axios.interceptors.request.use(function (request) {
  if (config.deviceInfoProvider) {
    var deviceInfo = config.deviceInfoProvider();
    request.headers = request.headers || {};
    request.headers['device-info'] = Base64.encode(JSON.stringify(deviceInfo));
  }

  return request;
}, function (error) {
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (!config.responseErrorHandler) {
    return Promise.reject(error);
  }

  if (!error.response || !error.response.status) {
    return Promise.reject(error);
  }

  config.responseErrorHandler(error.response.status, error);
  return Promise.reject(error);
});
export var http = {
  get: function get(url, config) {
    return axios.get(url, getConfig(config));
  },
  put: function put(url, payload, config) {
    return axios.put(url, payload, getConfig(config));
  },
  post: function post(url, payload, config) {
    return axios.post(url, payload, getConfig(config));
  },
  patch: function patch(url, payload, config) {
    return axios.patch(url, payload, getConfig(config));
  },
  head: function head(url, config) {
    return axios.head(url, getConfig(config));
  },
  delete: function _delete(url, config) {
    return axios.delete(url, getConfig(config));
  },
  isCancel: axios.isCancel
};